import { Col, Row, Space, Typography, Button } from "antd";
import { FC, useState } from "react";

import { useTheme } from "../../../Styles/ThemeHook";

type onAskFunction = (field: string) => Promise<Object>;

interface TechnicalItemProps {
	field: string;
	text: string;
	value: string;
	onAsk: onAskFunction;
	showSimilars: Function;
	isDisabledProperty?: boolean;
}

export const TechnicalItem: FC<TechnicalItemProps> = ({
	field,
	text,
	value,
	onAsk,
	showSimilars = null,
	isDisabledProperty = false,
}) => {
	const [asked, setAsked] = useState(false);
	const { theme } = useTheme();

	const askFastAction = async field => {
		let res = await onAsk(field);
		if (res) {
			setAsked(true);
			if (showSimilars) {
				showSimilars();
			}
		}
	};

	const SpanAskFast = ({ field }) => {
		if (asked) {
			return <Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>;
		} else {
			return (
				<Button
					type="text"
					ghost={true}
					disabled={isDisabledProperty}
					onClick={() => (!isDisabledProperty ? askFastAction(field) : null)}
					className="btnQuestion"
				>
					{"¡Preguntale!"}
				</Button>
			);
		}
	};

	return (
		<Row key={field} gutter={theme.spacing.mdSpacing} justify="space-between">
			<Col>
				<Space size={theme.spacing.xsSpacing}>
					<Typography.Text type={"secondary"} className="small">
						•{" "}
					</Typography.Text>
					<Typography.Text>{text}</Typography.Text>
				</Space>
			</Col>
			<Col flex={1} className="dots" />
			<Col>
				{value && value != null ? (
					<Typography.Paragraph
						strong
						title={value}
						style={{ margin: 0 }}
						ellipsis={{ rows: 2 }}>
						{value}
					</Typography.Paragraph>
				) : (
					<SpanAskFast field={field} />
				)}
			</Col>
		</Row>
	);
};
